import React from 'react';
import './home.css';
import HeaderImg from '../../components/header-img';
import image from '../../assets/default-lawyer-1.jpg';
import bma from '../../assets/bma.jpg';
import amdd from '../../assets/amddf.jpg';
import logoWhite from '../../assets/logo_black.png';


export default class Home extends React.Component {

  constructor(props) {
    super(props);
    this.content = props.content;
  }

  render() {
    return (
        <main>
          <HeaderImg img={image} height="59vh">
            <img src={logoWhite} className="logo-head" alt="Logo de Duque Banda Asociados"/>
          </HeaderImg>
          <div className="section">
            <div className="lema-container">
              <h1> {this.content.h1}</h1>
              <h2> {this.content.h2}</h2>
              <h3> {this.content.h3} </h3>
              <p>{this.content.slogan}</p>
            </div>
            <div className="semblanza">
              <p> {this.content.intro.p1}</p>
              <p> {this.content.intro.p2}</p>
              <div className="afiliations">
                <a href="http://www.bma.org.mx/" rel="noopener noreferrer" target="_blank"><img src={bma}
                                                                                                alt="logo barra mexicana de abogados"/></a>
                <a href="https://amdf.org.mx/" rel="noopener noreferrer" target="_blank"><img src={amdd}
                                                                                              alt="logo academia mexicana de derecho"/></a>
              </div>
            </div>
          </div>
        </main>
    );
  }
}
